// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__MqUCr","btn":"Pagination_btn__GwXRS","btnSelected":"Pagination_btnSelected__IHNsV"};